module.exports = __webpack_public_path__ + "img/135.5.1ef77d52.png";